import { getChildEntities } from 'app/infrastructure/store/query';
import {
  getCaseData,
  getEntityContext
} from 'app/infrastructure/ui/renderer/resolvers';
import { columnName, tableName } from 'app/area/case/case-data-model';
import { Entity, StoreField } from 'app/types-shared';

export const getGasTestMeasurementResults = (items: Entity[]) => {
  const gasTestMeasurements = columnName[tableName.gasTestMeasurement].gasTestResultCount;
  return items
    .map(r => r[gasTestMeasurements]?.[0])
    .filter(r => !!r);
};

export const getGasTestMeasurementResultGroupDetails = (gasTests: StoreField[]) => {

  if (!gasTests?.length) {
    return [];
  }

  const gasTestsGroupedByValue = gasTests.reduce((aggr, curr) => {
    aggr[curr.value] = aggr[curr.value] || [];
    aggr[curr.value].push(curr);
    return aggr;
  }, {});

  const gasTestValueGroups = Object.keys(gasTestsGroupedByValue)
    .map(e => gasTestsGroupedByValue[e]); //now convert the grouped objects to array

  return gasTestValueGroups.map(group => ({
    key: group[0].value,
    value: group.length,
    tooltip: group[0].description,
    backgroundColor: group[0].backgroundColor
  })); //set the result object having desired properties
};

export const gasTestValues = (caseState, uiEngineProps) => {
  const caseData = getCaseData(caseState, uiEngineProps);
  const entityContext = getEntityContext(caseState, uiEngineProps);

  const transPath = entityContext.path.slice(0, 1);

  const allGasTestMeasurements = getChildEntities(
    caseData,
    transPath,
    tableName.gasTestMeasurement
  );
  const gasTestMeasurementResults = getGasTestMeasurementResults(allGasTestMeasurements);

  const result = getGasTestMeasurementResultGroupDetails(gasTestMeasurementResults);

  return {
    gasTestResults: result,
    numberOfGasTestMeasurements: !!result?.length ? allGasTestMeasurements?.length : 0
  };
};

export interface GasTestResultShape {
  key: number;
  value: number;
  tooltip?: string;
  backgroundColor?: number;
}

export interface GasTestValuesShape {
  numberOfGasTestMeasurements: number;
  gasTestResults: GasTestResultShape[];
}
